module.exports = __webpack_public_path__ + "static/media/download_excel_icon.9f09f42e.svg";